import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import SetPropertyActionMetadata from 'automation-ui-action-features/actions/set-property/SetPropertyActionMetadata';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import SetPropertyActionDetail from 'automation-ui-action-features/actions/set-property/SetPropertyActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class SetPropertyActionHistoryCard extends Component {
  render() {
    const {
      actionId,
      actionLabel,
      actionMetadata,
      flowObjectTypeId,
      getActionLabelById,
      getActionOutputsForTargetActionById
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(SetPropertyActionDetail, {
        actionMetadata: actionMetadata,
        actionOutputs: getActionOutputsForTargetActionById(actionId),
        flowObjectTypeId: flowObjectTypeId,
        getActionLabelById: getActionLabelById
      })
    });
  }
}
SetPropertyActionHistoryCard.propTypes = {
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  actionLabel: PropTypes.node,
  actionMetadata: PropTypes.instanceOf(SetPropertyActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType,
  getActionLabelById: PropTypes.func.isRequired,
  getActionOutputsForTargetActionById: PropTypes.func.isRequired
};
export default SetPropertyActionHistoryCard;